<template>
  <div>
    <v-row align="center" dense>
      <span class="ml-1">
        Deployment ({{ schedulingSelector ? 'labels' : 'specific devices' }})
      </span>
      <v-spacer></v-spacer>
      <v-switch
        label="Select by labels"
        v-model="schedulingSelector"                
      ></v-switch>
    </v-row>

    <!-- Select by labels -->
    <v-row v-if="schedulingSelector" align="center" dense>
      <v-col cols="12" sm="6" md="6">
        <v-text-field 
          required 
          label="Key"
          outlined
          :value="selectorKey"
          v-model="internalSelectorKey"
          @change="$emit('update:selectorKey', internalSelectorKey)"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          required
          label="Value"
          outlined
          :value="selectorValue"
          v-model="internalSelectorValue"
          @change="$emit('update:selectorValue', internalSelectorValue)"
        />
      </v-col>
    </v-row>

    <!-- Select directly -->
    <v-row v-else align="center" dense>
      <v-col cols="12" sm="12" md="12">
        <v-select
          no-data-text="No devices added to your project"
          v-model="internalSelectedDevices"
          @change="$emit('update:selectedDevices', internalSelectedDevices)"
          :items="devices"
          item-text="name"
          item-value="id"
          chips
          label="Select one or more devices to deploy this application to..."
          multiple
          small
          outlined
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      schedulingSelector: false,

      internalSelectedDevices: [],
      internalSelectorValue: '',
      internalSelectorKey: '',
        
      missingGpu: false
    }
  },

  props: {
    devices: Array,
    selectedDevices: Array,
    selectorKey: String,
    selectorValue: String    
  },

  emits: [
    'update:selectedDevices',
    'update:selectorKey',
    'update:selectorValue',
  ],

  mounted () {
    // If there's only one device, select it
    if (this.devices.length === 1) {  
      this.internalSelectedDevices = [this.devices[0].id] 
      // Emit the change
      this.$emit('update:selectedDevices', this.internalSelectedDevices)
    }
  },
}
</script>